var scope_0 = require('/Users/jxie/projects/lyra/packages/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0fb157dea6aeff5858da169bba6f1679.js').default;
var scope_1 = require('/Users/jxie/projects/lyra/packages/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1b974076421e394db680a34293532c69.js').default;
var scope_2 = require('/Users/jxie/projects/lyra/packages/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2787125e425aeedf56d234815797922a.js').default;
var scope_3 = require('/Users/jxie/projects/lyra/packages/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3bc83fa78546d61254c682d8bcfdb083.js').default;
var scope_4 = require('/Users/jxie/projects/lyra/packages/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4aa922e6c9004c2acfc9e3f9e26f2133.js').default;
var scope_5 = require('/Users/jxie/projects/lyra/packages/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/61171c1b905816df8763cfab37ec95cc.js').default;
var scope_6 = require('/Users/jxie/projects/lyra/packages/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/721a79fdcc996b6a90faf955aee6aae4.js').default;
var scope_7 = require('/Users/jxie/projects/lyra/packages/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9ed1a973562dac0068bea0028bafb329.js').default;
var scope_8 = require('/Users/jxie/projects/lyra/packages/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a4834abc7788e62455d4abe847e4ae32.js').default;
var scope_9 = require('/Users/jxie/projects/lyra/packages/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b4c90090121427bd889ea719e4c57ad7.js').default;
var scope_10 = require('/Users/jxie/projects/lyra/packages/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d4e7230c74103b7d7364e2891c1a0353.js').default;
var scope_11 = require('/Users/jxie/projects/lyra/packages/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d65e62950b26b3fdeaa78ea8d6534881.js').default;
var scope_12 = require('/Users/jxie/projects/lyra/packages/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_13 = require('/Users/jxie/projects/lyra/packages/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/eff53ef35f4d60ffd6674c96926f85fd.js').default;
var scope_14 = require('/Users/jxie/projects/lyra/packages/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f72aa3efdce191894979ebe28bba7408.js').default;
var scope_15 = require('/Users/jxie/projects/lyra/packages/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fdcd8117f787af465cdd5a611c184661.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13,
scope_14,
scope_15 )
    